import { request, chatbotUrl}  from '../utils/request';
import { APP_CONFIG } from '../utils/config';

export function getSsoCheck(props) {
    
    const params = { }
    
    const requestUrl = chatbotUrl(props.config.isDev) + APP_CONFIG.getSsoStatus;
    return request(requestUrl, 'post', params);
}
